import MenuButton from "./MenuButton";
import { SECTIONIDS } from "../../constants/sectionId";

const Navbar = () => {
  return (
    <>
      <header className="fixed top-0 w-full h-max z-[100]">
        <nav className="2lg:px-12 mx-auto max-w-7xl px-6 py-6 xl:py-12 lg:px-12 xl:px-6 2xl:px-0 ">
          <div className="relative flex items-center justify-between">
            <a
              href={`/#${SECTIONIDS.HERO}`}
              className="text-2xl font-light tracking-widest text-white"
            >
              EROM STUDIO
            </a>

            {/* <Button className={'hidden md:flex'} label="Get in touch" href={`mailto:${process.env.REACT_APP_EMAIL}`} /> */}
            <MenuButton></MenuButton>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
